import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sz_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && localStorage.getItem("sz_token") && !url.includes("/auth/login")) {
      localStorage.removeItem("sz_token");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

// Authed direct file URL (goods invoice, POD) — token as query param, same as the app
export const authedFileUrl = (path) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/app/${path}?token=${encodeURIComponent(localStorage.getItem("sz_token") || "")}`;

export const appApi = {
  get: (p, params) => api.get(`/app/${p}`, { params }).then((r) => r.data),
  post: (p, body) => api.post(`/app/${p}`, body ?? {}).then((r) => r.data),
  put: (p, body) => api.put(`/app/${p}`, body ?? {}).then((r) => r.data),
  patch: (p, body) => api.patch(`/app/${p}`, body ?? {}).then((r) => r.data),
  del: (p) => api.delete(`/app/${p}`).then((r) => r.data),
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const inrPaise = (p) => inr((p || 0) / 100);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

